import { AnalyticsBrowser } from '@segment/analytics-next';
import { getReferralKeyFromUrl } from './getReferralKeyFromUrl';
import {
  ElementClickedTrackProperties,
  ExperimentViewTrackProperties,
  IdentifyTraits,
  PageViewTrackProperties,
} from '../types/segmentTypes';

interface InitializeProps {
  segmentWriteKey: string;
}

class SegmentClient {
  private static referralKey = getReferralKeyFromUrl();
  private static referralData = SegmentClient.referralKey
    ? { referral_key: SegmentClient.referralKey }
    : {};
  private static baseSegmentClient: AnalyticsBrowser;
  private static hasBeenInitialized = false;
  private static hasBeenIdentified = false;

  public static getHasBeenInitialized(): boolean {
    return this.hasBeenInitialized;
  }

  public static getHasBeenIdentified(): boolean {
    return this.hasBeenIdentified;
  }

  static initialize({ segmentWriteKey }: InitializeProps): void {
    this.baseSegmentClient = AnalyticsBrowser.load({
      writeKey: segmentWriteKey,
    });
    this.hasBeenInitialized = true;
  }

  static identify(traits: IdentifyTraits): void {
    if (!this.hasBeenInitialized) {
      this.warnClientIsNotInitialized();
      return;
    }

    this.baseSegmentClient.identify(null, traits, () => {
      this.hasBeenIdentified = true;
    });
  }

  static trackElementClick(properties: ElementClickedTrackProperties): void {
    if (!this.hasBeenInitialized) {
      this.warnClientIsNotInitialized();
      return;
    }

    this.baseSegmentClient.track('Element Clicked', {
      page: window.location.href,
      path: window.location.pathname,
      ...this.referralData,
      ...properties,
    });
  }

  static trackPageView(
    name: string,
    properties?: PageViewTrackProperties,
    category?: string
  ): void {
    if (!this.hasBeenInitialized) {
      this.warnClientIsNotInitialized();
      return;
    }

    this.baseSegmentClient.page(category, name, {
      path: window.location.pathname,
      url: window.location.href,
      referrer: document.referrer,
      title: document.title,
      ...this.referralData,
      ...properties,
    });
  }

  static trackExperimentView(properties: ExperimentViewTrackProperties): void {
    if (!this.hasBeenInitialized) {
      this.warnClientIsNotInitialized();
      return;
    }

    this.baseSegmentClient.track('Experiment Viewed', {
      ...this.referralData,
      ...properties,
    });
  }

  private static warnClientIsNotInitialized(): void {
    // eslint-disable-next-line no-console
    console.warn(
      'The SegmentClient has not been initialized yet. Please initialize the SegmentClient with your Segment Write Key.'
    );
  }
}

export { SegmentClient };
